import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Console } from 'console';
import { AnyRecord } from 'dns';
import autoTable from 'jspdf-autotable';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { CategoryLan } from 'src/app/shared/models/CategoryLan';
import { PeriodsVO } from 'src/app/shared/models/PeriodsVO';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';

import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-sts-guide',
  templateUrl: './sts-guide.component.html',
  styleUrls: ['./sts-guide.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class StsGuideComponent implements OnInit {

  token: string;
  security: SecurityDocument;
  lstRespTranslate: TranslateRelLabelVO[];
  loadingSearch: boolean = false;
  backToStoreId: string;
  selStoreId: string;

  listPeriods: PeriodsVO[];
  selectedPeriod: PeriodsVO;

  listStatus: any[];
  selectedStatus: any;

  listStatisticsZones: any[];
  selectedStatistic: any;

  lbl_zone: string = "zone_";
  lbl_period: string = "period_";
  lbl_select: string = "select_";
  lbl_search: string = "search_";
  lbl_total: string = "total_";
  lbl_status: string = "status_";
  lbl_back: string = "back_";
  lbl_guides: string = "guides_";
  lbl_summary: string = "summary_";
  lbl_coordination: string = "coordination_";
  lbl_coordinations: string = "coordinations_";

  data: any;
  chartOptions: any;

  blocked: boolean = false;
  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private tovpilUtils: TovpilUtilsService) {
    this.route.queryParams
      .subscribe(
        params => {
          this.token = params.token;
          this.selStoreId = params.selStoreId;
          this.backToStoreId = params.backToStoreId;
        });
    this.getSecurity();
  }

  ngOnInit(): void {
    this.listStatus = [];
    this.listStatus.push({ id: "A", descrip: "Activos" });
    this.listStatus.push({ id: "E", descrip: "Emeritos" });
    this.listStatus.push({ id: "B", descrip: "Bajas" });

    this.selectedStatus = { id: "A", descrip: "Activos" };

    this.chartOptions = {
      plugins: {
        legend: {
          labels: {
            color: '#495057'
          }
        }
      },
      scales: {
        x: {
          beginAtZero: true,
          ticks: {
            color: '#495057'
          },
          grid: {
            color: '#ebedef'
          }
        },
        y: {
          beginAtZero: true,
          ticks: {
            color: '#495057'
          },
          grid: {
            color: '#ebedef'
          }
        }
      },
      responsive: true
    };

  }

  search() {
    this.listStatisticsZones = [];
    if (this.selectedStatus) {
      this.loadingSearch = true;
      this.getDataStatistic();
    } else {
      this.messageService.add({ severity: 'error', summary: 'Consulta Información', detail: 'Favor de llenar información requerida', life: 3000 });
    }
  };


  getValidPeriods() {
    this.apiService.getValidPeriods(this.security.language).then(
      data => {
        this.listPeriods = data;
        this.selectedPeriod = this.listPeriods[0];
        this.search();
      });
  }

  getDataStatistic() {
    this.blocked = true;

    this.apiService.getGuidesByZoneStatistics({ "year": this.selectedPeriod.year, "period": this.selectedPeriod.period, "status": this.selectedStatus.id, "token": this.token,"storeId": this.selStoreId }).then(
      data => {
        this.listStatisticsZones = data;
        this.loadingSearch = false;
        this.blocked = false;
        this.updateGraph();
        this.messageService.add({ severity: 'success', summary: 'Consulta Información', detail: 'La información se cargo correctamente', life: 3000 });
      }).catch(error => {
        this.blocked = false;
        console.error(error);
      });

  }

  getSecurity() {

    this.apiService.findSecurityById({ "id": this.token }).then(
      data => {
        this.security = data;
        this.getTranslatedLabels();
        this.getValidPeriods();

      });
  }

  getTranslatedLabels() {
    let map = new Map();
    let lstCat: CategoryLan[];

    this.apiService.listByLanguageMultFields({
      'language': this.security.language,
      'region': this.security.region,
      'lstLabels': [this.lbl_select, this.lbl_period, this.lbl_search, this.lbl_total, this.lbl_zone, this.lbl_status, this.lbl_back,
      this.lbl_guides, this.lbl_summary, this.lbl_coordination, this.lbl_coordinations]
    }).then(
      trDocs => {
        this.lstRespTranslate = trDocs;

        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });
        this.lbl_select = map.get(this.lbl_select);
        this.lbl_zone = map.get(this.lbl_zone);
        this.lbl_search = map.get(this.lbl_search);
        this.lbl_period = map.get(this.lbl_period);
        this.lbl_total = map.get(this.lbl_total);
        this.lbl_status = map.get(this.lbl_status);
        this.lbl_back = map.get(this.lbl_back);
        this.lbl_guides = map.get(this.lbl_guides);
        this.lbl_summary = map.get(this.lbl_summary);
        this.lbl_coordination = map.get(this.lbl_coordination);
        this.lbl_coordinations = map.get(this.lbl_coordinations);
      });
  }

  updateGraph() {
    let labels = [];
    let dataValue = [];
    this.listStatisticsZones.forEach((staticReport) => {
      labels.push(staticReport.description);
      dataValue.push(staticReport.total);

    });
    this.data = {
      labels: labels,
      datasets: [
        {
          label: this.selectedPeriod.descrip + ",  " + this.lbl_status + " - " + this.selectedStatus.descrip,
          data: dataValue,
          backgroundColor: [
            "#42A5F5",
            "#66BB6A",
            "#FFA726",
            "#CF42BB",
            "#eee886",
            "#66D7D1",
            "#e88648",
            "#FF637D",
            "#FE2D07",
            "#5F28FA",
            "#036C81",
            "#6FD804",
            "#D88B06",
            "#0C9C5B",
            "#C219B4",
            "#6A7CFB",
            "#F8E12B",
            "#42A5F5",
            "#66BB6A",
            "#FFA726",
            "#CF42BB",
            "#eee886",
            "#66D7D1",
            "#e88648",
            "#FF637D",
            "#FE2D07",
            "#5F28FA",
            "#036C81",
            "#6FD804",
            "#D88B06",
            "#0C9C5B",
            "#C219B4",
            "#6A7CFB",
            "#F8E12B"

          ],
          borderColor: [
            "#64B5F6",
            "#81C784",
            "#FFB74D",
            "#CF42EB",
            "#F4F1BB",
            "#aceae6",
            "#f0b38d",
            "#f5a3b1",
            "#FF637D",
            "#E98674",
            "#AF8FF9",
            "#479DB0",
            '#CCF6A3',
            "#F2D8B1",
            "#894A48",
            "#408C6A",
            "#B9B170",
            "#64B5F6",
            "#81C784",
            "#FFB74D",
            "#CF42EB",
            "#F4F1BB",
            "#aceae6",
            "#f0b38d",
            "#f5a3b1",
            "#FF637D",
            "#E98674",
            "#AF8FF9",
            "#479DB0",
            '#CCF6A3',
            "#F2D8B1",
            "#894A48",
            "#408C6A",
            "#B9B170"
          ]
        }
      ]
    };



  }

  exportExcel() {
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.listStatisticsZones);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "estadistic-zone");
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  goBackClose() {

    let strBack: string;

    if (this.backToStoreId == null) {
      window.close();
    } else {
      let vals = this.backToStoreId.split(",");
      if (vals.length == 1) {
        strBack = vals[0];
        this.backToStoreId = null;
      } else {
        if (vals.length == 2) {
          this.backToStoreId = vals[0];
          strBack = vals[1];
        } else if (vals.length >= 3) {
          this.backToStoreId = vals[0] + "," + vals[1];
          strBack = vals[2];
        }
      }
      this.router.navigate(['reports/stsGuides'], { queryParams: { token: this.token, selStoreId: strBack, selectedYear: this.selectedPeriod.year, selectedPeriod: this.selectedPeriod.period, backToStoreId: this.backToStoreId } }).then(() => {
        window.location.reload();
      });

    }
  }
  selectRecord(str: string) {
    let next: boolean = false;
    if (this.backToStoreId == null) {
      this.backToStoreId = this.security.storeId;
      next = true;
    } else {
      let vals = this.backToStoreId.split(",");
      if (this.selStoreId != null && vals.length < 2) {
        this.backToStoreId = this.backToStoreId + "," + this.selStoreId;
        next = true;
      } else {
        next = false;
      }
    }
    if (next) {
      this.router.navigate(['reports/stsGuides'], { queryParams: { token: this.token, selStoreId: str, selectedYear: this.selectedPeriod.year, selectedPeriod: this.selectedPeriod.period, backToStoreId: this.backToStoreId } }).then(() => {
        window.location.reload();
      });
    }
  }

}
